import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { REST_ENPOINTS } from "../../../constants/enpoints";

const initialState = {
  createForm: { name: "" },
  updateForm: { id: null, name: "", imageUrl: "" },
  file: "",
  uploadPreview: null,
  uploadLoading: false,
  uploadError: null,
  isEdit: false,
};

export const uploadCountryImage = createAsyncThunk(
  "country/upload",
  async (args, thunkAPI) => {
    const { file } = thunkAPI.getState().country;
    try {
      const res = await axios.post(REST_ENPOINTS.uploadCountryImage, { file });
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

const countrySlice = createSlice({
  name: "country",
  initialState,
  reducers: {
    onChangeCountryForm: (state, { payload }) => {
      if (state.isEdit) {
        state.updateForm = {
          ...state.updateForm,
          name: payload.name,
        };
      } else {
        state.createForm = {
          ...state.createForm,
          name: payload.name,
        };
      }
    },
    setCountryImageFile: (state, { payload }) => {
      state.file = payload;
    },
    setCountryImagePreview: (state, { payload }) => {
      state.uploadPreview = payload;
    },
    setIsEditCountry: (state, { payload }) => {
      state.isEdit = payload;
    },
    setUpdateCountry: (state, { payload }) => {
      state.isEdit = true;
      state.updateForm = payload;
    },
    clearCountryForm: (state) => {
      state.createForm = initialState.createForm;
      state.updateForm = initialState.updateForm;
      state.uploadPreview = initialState.uploadPreview;
      state.file = initialState.file;
    },
    removeCountryImage: (state) => {
      state.uploadPreview = initialState.uploadPreview;
      state.file = initialState.file;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadCountryImage.pending, (state) => {
        state.uploadLoading = true;
      })
      .addCase(uploadCountryImage.fulfilled, (state) => {
        state.uploadLoading = false;
      })
      .addCase(uploadCountryImage.rejected, (state, action) => {
        state.uploadLoading = false;
        state.uploadError = action.payload;
      });
  },
});

export const {
  onChangeCountryForm,
  setCountryImageFile,
  setCountryImagePreview,
  setIsEditCountry,
  setUpdateCountry,
  clearCountryForm,
  removeCountryImage,
} = countrySlice.actions;

export default countrySlice.reducer;
